import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { hrDocumentApi } from '../../services/hrDocumentApi';

export default function DocumentVerifyPage() {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [birthdate, setBirthdate] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (!/^\d{6}$/.test(birthdate)) {
      setError('생년월일은 6자리 숫자(YYMMDD)로 입력해주세요.');
      return;
    }

    setLoading(true);
    try {
      const result = await hrDocumentApi.verify(name.trim(), birthdate.trim());
      navigate('/document/select', { state: { ...result, birthdate: birthdate.trim() } });
    } catch (err: any) {
      const msg = err?.response?.data?.message;
      setError(msg || '일치하는 직원 정보를 찾을 수 없습니다. 다시 확인해주세요.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-100 flex items-center justify-center p-4">
      <div className="w-full max-w-sm">
        {/* 로고/타이틀 */}
        <div className="text-center mb-8">
          <h1 className="text-xl font-bold text-slate-800">GRK Career Management</h1>
          <p className="text-sm text-slate-500 mt-1">증명서 발급 포털</p>
        </div>

        {/* 카드 */}
        <div className="bg-white rounded-xl shadow border border-slate-200 p-6">
          <h2 className="text-base font-semibold text-slate-800 mb-1">본인 확인</h2>
          <p className="text-xs text-slate-500 mb-5">
            이름과 생년월일을 입력하시면 발급 가능한 증명서를 확인하실 수 있습니다.
          </p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-xs font-medium text-slate-700 mb-1">이름</label>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="홍길동"
                required
                className="w-full px-3 py-2 text-sm border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
              />
            </div>

            <div>
              <label className="block text-xs font-medium text-slate-700 mb-1">
                생년월일 <span className="text-slate-400 font-normal">(YYMMDD, 예: 901225)</span>
              </label>
              <input
                type="text"
                value={birthdate}
                onChange={(e) => setBirthdate(e.target.value.replace(/\D/g, '').slice(0, 6))}
                placeholder="901225"
                maxLength={6}
                required
                className="w-full px-3 py-2 text-sm border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
              />
            </div>

            {error && (
              <div className="bg-red-50 border border-red-200 rounded-lg px-3 py-2">
                <p className="text-xs text-red-600">{error}</p>
              </div>
            )}

            <button
              type="submit"
              disabled={loading || !name.trim() || birthdate.length !== 6}
              className="w-full py-2.5 bg-indigo-600 hover:bg-indigo-700 disabled:bg-indigo-300 text-white text-sm font-medium rounded-lg transition-colors"
            >
              {loading ? '확인 중...' : '본인 확인'}
            </button>
          </form>
        </div>

        <p className="text-xs text-slate-400 text-center mt-4">
          재직·퇴직 직원만 이용 가능합니다.
        </p>
        <button
          onClick={() => navigate('/login')}
          className="w-full text-center text-xs text-slate-400 hover:text-slate-600 mt-2 py-2 transition-colors"
        >
          ← 처음으로
        </button>
      </div>
    </div>
  );
}
